import { useDispatch, useSelector } from "react-redux";
import { ChannelProgram } from "src/models";
import { DateService, _ } from "src/services";
import { TvAction, TvModel } from "src/store";
import indicator from "src/assets/static/img/main/anten-indicator.svg";

export const TvConductorProgramCard: React.FC<ChannelProgram> = ({
    currentProgram, hasEpisode, duration, startAt, title, id, ...props
}) => {

    const dispatch = useDispatch();
    const conductor: TvModel = useSelector((state: any) => state.TvState);

    const onClick = () => {
        if (isSelected) return;
        dispatch(TvAction.setCurrentEpisode({ currentProgram, hasEpisode, duration, startAt, title, id, ...props }));
    };

    const isSelected = (conductor.episode && conductor.episode.id === id) || (!conductor.episode && currentProgram);

    let className = "conductor w-100 px-3 py-1 border-bottom";
    if (hasEpisode) className += " archive-episod";
    if (hasEpisode || currentProgram) className += " cursor-pointer";
    if (isSelected) className += " selected-episode";

    const style = isSelected ? { backgroundImage: `url(${indicator})` } : {};

    return (
        <div onClick={onClick} className={className} style={style}>
            <div className="row">
                <div className="col-2">
                    <div className="time">
                        {DateService.persianDate(startAt, "HH:mm")}
                    </div>
                </div>
                <div className="col-10">
                    <div className="text-right text-rtl name">
                        {title}
                        {
                            currentProgram &&
                            <span className="mr-1 d-inline-block badge-live" />
                        }
                    </div>
                    <div className="text-right duration text-rtl">
                        <span>{duration}</span>
                        {
                            hasEpisode &&
                            <>
                                <span className="circle d-inline-block" />
                                <span className="d-inline-block">{_("archive")}</span>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );

};